import { render, staticRenderFns } from "./InternalMenu.vue?vue&type=template&id=b98ad81e"
import script from "./InternalMenu.vue?vue&type=script&lang=js"
export * from "./InternalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports